import { themeQuartz, iconSetQuartzLight } from 'ag-grid-enterprise'

const printTheme = themeQuartz.withPart(iconSetQuartzLight).withParams({
  browserColorScheme: 'light',
  columnBorder: true,
  fontFamily: '"Noto Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  fontSize: 12,
  foregroundColor: 'rgb(46, 55, 66)',
  headerBackgroundColor: '#F9FAFB',
  headerFontFamily: '"Roboto", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  headerFontSize: 7,
  headerFontWeight: 550,
  headerTextColor: '#1f1f1f',
  rowBorder: true,
  cellHorizontalPadding: 4,
  headerHeight: 24,
  // spacing: 0.5,
  textColor: 'rgba(0, 0, 0, 0.88)',
  wrapperBorderRadius: 3
})

export default printTheme
